<template>
  <zm-banner class="opc-edu-switch-tip" type="info">
    <div class="opc-edu-switch-tip__message">
      {{ t('billing.zone_edu_sch.switch_info', [plan, t('billing.planform.title.zoom_one_education')]) }}
    </div>
  </zm-banner>
</template>

<script setup>
import { useI18n } from 'vue-i18n';

defineProps({
  plan: {
    type: String,
  },
});

const { t } = useI18n();
</script>

<style lang="scss" scoped>
.opc-edu-switch-tip {
  margin-bottom: 24px;
  background-color: #f7f7f8;

  :deep {
    .zbo-banner {
      &__body {
        padding: 0;
      }
      &__content {
        display: flex;
        align-items: center;
      }
    }
  }

  &__message {
    flex-grow: 1;
    line-height: 1.5;
    font-size: 14px;
    font-weight: 450;
    font-style: normal;
    color: #666487;
  }
}
</style>
